import algoliasearch from 'algoliasearch'

const { VUE_APP_ALGOLIA_APP = '', VUE_APP_ALGOLIA_KEY = '' } = process.env

const client = algoliasearch(VUE_APP_ALGOLIA_APP, VUE_APP_ALGOLIA_KEY)

export default client
